import { Component, OnInit } from '@angular/core';
import {BasicParametersComponent} from '../../basic-parameters/basic-parameters.component';
import {FormBuilder, FormControl} from '@angular/forms';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';
import {AlertaService} from '../../../../../../shared/services/alerta.service';
import { Observable } from 'rxjs';
import { MiscelaneaService } from 'app/shared/services/miscelanea.service';

@Component({
  selector: 'app-beeztel-basic-parameters',
  templateUrl: './beeztel-basic-parameters.component.html',
  styleUrls: ['./beeztel-basic-parameters.component.scss']
})
export class BeeztelBasicParametersComponent extends BasicParametersComponent implements OnInit {

  constructor(protected fb: FormBuilder, protected portalCampFactory: PortalServiceFactoryService,
    protected alertHandler: AlertaService, private miscHandler: MiscelaneaService) {
      super(fb, portalCampFactory, alertHandler);

      this.form.setControl('hlr_context_id', new FormControl());
      this.form.setControl('verify_caller_id', new FormControl('0'));
      this.form.setControl('verify_caller_id_destination_numbers', new FormControl());
      this.form.setControl('verify_caller_id_spam_responses', new FormControl());
      this.form.setControl('use_attempts_by_campaign', new FormControl('0'));
  }

  requestAutocompleteResponse = (text: string): Observable<any> => {
    return this.miscHandler.findAllPhonePossibleResponses({ 'provider' : 'beeztel' }, text);
  };

  ngOnInit() {
      super.ngOnInit();
      console.log(this.portalService);

      if (this.portalService.config.hasOwnProperty('verify_caller_id')) {
          this.form.controls['verify_caller_id'].setValue(this.portalService.config['verify_caller_id']);
      }

      if (this.portalService.config.hasOwnProperty('verify_caller_id_destination_numbers')) {
          this.form.controls['verify_caller_id_destination_numbers'].setValue(
           this.portalService.config['verify_caller_id_destination_numbers'].map(
             (value) => {
               return { value: value, display: value}
             }
           )
          );
      }

      if (this.portalService.config.hasOwnProperty('verify_caller_id_spam_responses')) {
        this.form.controls['verify_caller_id_spam_responses'].setValue(
          this.portalService.config['verify_caller_id_spam_responses'].map(
            (value) => {
              return { value: value, display: value}
            }
          )
         );
      }

      if (this.portalService.config.hasOwnProperty('use_attempts_by_campaign')) {
        this.form.controls['use_attempts_by_campaign'].setValue(this.portalService.config['use_attempts_by_campaign']);
      }

  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/beeztel/beeztel-basic-parameters/beeztel-basic-parameters.component.ts